import type { FaireProductEntity } from "../../entity_types/product";

export const p_trk8jytxjt: FaireProductEntity = {
  token: "p_trk8jytxjt",
  type: "product",
  name: "DEWY YOU Gift Set: Repair + Hydrating Mist + Vitamin C",
  brandToken: "b_cdcjvt8t",
  brandName: "Earth Harbor Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/c1cfbb3fdebc011e1bd8ffc758831af4f29c417fd3067d6fb167f785456bf2d7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa0f604dd92780d8794f3703cd62a4fc45833937792c39c48f6433fc12082c33.jpeg",
  ],
  priceDollars: 10,
  description:
    "A luminous mini collection for naturally repairing + hydrating your precious skin. Created for all skin types, but especially beneficial for skin in need of deep hydration, rich nutrients, and restoring radiance. This is the perfect discovery kit for experiencing Earth Harbor's customizable skincare rituals through mixing, blending, and layering products for personalized results.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:16.121Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
